
import { createContext } from 'react';

interface CustomSelectContextType {
  value: string;
  onValueChange: (value: string) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onOpenChange?: (open: boolean) => void;
}

export const CustomSelectContext = createContext<CustomSelectContextType>({
  value: '',
  onValueChange: () => {},
  isOpen: false,
  setIsOpen: () => {},
});

interface CustomSelectProviderProps {
  value: string;
  onValueChange: (value: string) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
}

export const CustomSelectProvider: React.FC<CustomSelectProviderProps> = ({
  value,
  onValueChange,
  isOpen,
  setIsOpen,
  onOpenChange,
  children
}) => {
  return (
    <CustomSelectContext.Provider value={{ 
      value, 
      onValueChange, 
      isOpen, 
      setIsOpen,
      onOpenChange 
    }}>
      {children}
    </CustomSelectContext.Provider>
  );
};
